import React from "react";
import {
	Users,
	Patients,
	Institutions,
	Demography,
	Diagnostic,
	Samples,
	Patient,
	Treatments,
	LabReport,
	Final
} from "../pages";

export const privateRoutes: RouteType[] = [
	//SideBarLayout
	{
		path: "/users",
		element: <Users />,
		layout: "SideBarLayout",
	},
	{
		path: "/patients",
		element: <Patients />,
		layout: "SideBarLayout",
	},
	{
		path: "/institutions",
		element: <Institutions />,
		layout: "SideBarLayout",
	},
	//NewPatientLayout
	{
		path: "",
		element: <Demography />,
		layout: "NewPatientLayout",
	},
	{
		path: "demography",
		element: <Demography />,
		layout: "NewPatientLayout",
	},
	{
		path: "diagnostic",
		element: <Diagnostic />,
		layout: "NewPatientLayout",
	},
	{
		path: "samples",
		element: <Samples />,
		layout: "NewPatientLayout",
	},
	{
		path: "treatments",
		element: <Treatments />,
		layout: "NewPatientLayout",
	},
	{
		path: "lab-report",
		element: <LabReport />,
		layout: "NewPatientLayout",
	},
	{
		path: "final",
		element: <Final />,
		layout: "NewPatientLayout",
	},
	//PatientLayout
	{
		path: '/patient/:patientId',
		element: <Patient />,
		layout: 'SideBarLayout'
	}
];
